import React from "react";
import { ILikeProps } from "../types";
import styles from "./index.module.less";
import { message } from "antd";
import Icon from "@Components/icon";

const Like: React.FC<ILikeProps> = (props: ILikeProps) => {
  const { likeStatus, likeCount, id, onClickLike } = props;

  const onFavour = () => {
    if (likeStatus) {
      message.error("你已經讚過了噢~");
      return;
    }
    onClickLike(id, !likeStatus);
  };

  return (
    <section
      className={styles["Like"]}
      onClick={() => {
        onFavour();
      }}
    >
      <Icon type={!likeStatus ? "icon-zan" : "icon-liked"} />
      {Boolean(likeCount) && likeCount}
    </section>
  );
};
export default Like;
